module.exports = __webpack_public_path__ + "static/media/upload.b85fa1ee.png";